import React from 'react'
import './Login.css'

import { Logo } from '../../../utils'
import LoginFunction from '../../../utils/CommonFunctionality/LoginFunction'

const LoginComponent = () => {
    return (
        <div className="clearfix row vcaLogin">
            <div className="col-lg-6 d-none d-lg-block pad-0">
                {global.storeDetails?.site_id == 'AS0605' ||
                global.storeDetails?.site_id == 'AS0732' ? (
                    <div className="loginImgBox loginImgBoxCincy d-flex justify-content-between flex-column"></div>
                ) : (
                    <div className="loginImgBox d-flex justify-content-between flex-column"></div>
                )}
            </div>
            <div className="col-lg-6 col-12">
                <div className="loginFormBox">
                    <Logo className="m-auto" />
                    <LoginFunction title="Login" subTitle="Welcome Back" />
                </div>
            </div>
        </div>
    )
}

export default LoginComponent
